function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 18.567,
    viewBox: "0 0 26.458 4.9126",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-37.867 -81.506)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.62707 0 0 .62707 23.971 10.681)",
    fill: "#314f61"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m83.758 427.37v3.5059h3.7891v-0.12696h6.0156c2.2526 0 3.8867 0.19531 4.9023 0.58594 1.4062 0.54687 2.5977 1.6276 3.5742 3.2422 0.98958 1.6016 1.4844 3.8998 1.4844 6.8945 0 2.1615-0.25391 4.0039-0.76172 5.5273-0.49479 1.5104-1.1914 2.7148-2.0898 3.6133-0.63802 0.638-1.4974 1.1328-2.5781 1.4844-1.0677 0.35157-2.5456 0.52734-4.4336 0.52734h-6.1133v-12.979h-3.7891v16.357h10.332c1.7318 0 3.2617-0.16274 4.5898-0.48828 1.3411-0.32552 2.4805-0.8008 3.418-1.4258 0.95051-0.63804 1.8229-1.5039 2.6172-2.5977 0.79427-1.1068 1.4453-2.5 1.9531-4.1797 0.50781-1.6797 0.76172-3.6068 0.76172-5.7812 0-2.5521-0.37761-4.8177-1.1328-6.7969-0.74219-1.9922-1.8685-3.6263-3.3789-4.9024-1.1588-0.98958-2.5586-1.6732-4.1992-2.0508-1.1719-0.27343-2.8711-0.41015-5.0977-0.41015z",
    style: {
      shapeInside: "url(#rect14)",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m120.52 427.37-10.996 28.633h4.0234l8.9258-25.254 9.5312 25.254h4.3164l-11.719-28.633z",
    style: {
      shapeInside: "url(#rect14)",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m139.46 427.37v3.3789h20.703v-3.3789zm0 12.148v3.3594h19.629v-3.3594h-15.84zm0 13.105v3.3789h21.367v-3.3789h-17.578z",
    style: {
      shapeInside: "url(#rect14)",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.178 120.65 2.93-3.9481-2.5838-3.6277h1.1937l1.3746 1.943q0.42891 0.60461 0.60978 0.93017 0.25321-0.41341 0.59944-0.86299l1.5244-2.0102h1.0904l-2.6613 3.5708 2.868 4.0049h-1.2402l-1.9069-2.7027q-0.1602-0.23255-0.33073-0.50643-0.25321 0.41341-0.36173 0.56844l-1.9017 2.6407z",
    style: {
      shapeInside: "url(#rect14)",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.988 113.07h1.0025v4.377q0 1.142-0.25838 1.8138-0.25838 0.67179-0.93534 1.0955-0.67179 0.41858-1.7673 0.41858-1.0645 0-1.7415-0.36691-0.67696-0.3669-0.96635-1.0594-0.28939-0.69763-0.28939-1.9017v-4.377h1.0025v4.3718q0 0.98701 0.18087 1.4573 0.18603 0.46508 0.63045 0.7183 0.44958 0.25321 1.0955 0.25321 1.1059 0 1.5761-0.50126t0.47025-1.9275z",
    style: {
      shapeInside: "url(#rect14)",
      whiteSpace: "pre"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.324 118.22 0.94568-0.0827q0.06718 0.56844 0.31006 0.93534 0.24805 0.36174 0.76481 0.58911 0.51676 0.22221 1.1627 0.22221 0.57361 0 1.0129-0.17053 0.43925-0.17053 0.65112-0.46509 0.21704-0.29972 0.21704-0.65112 0-0.35657-0.2067-0.62012-0.20671-0.26871-0.68213-0.44958-0.30489-0.11885-1.3488-0.3669-1.0439-0.25321-1.4624-0.47542-0.5426-0.28422-0.81132-0.7028-0.26355-0.42374-0.26355-0.94568 0-0.5736 0.32556-1.0697 0.32556-0.50126 0.95084-0.75965 0.62528-0.25838 1.3901-0.25838 0.84232 0 1.4831 0.27389 0.64595 0.26871 0.99218 0.79581t0.37207 1.1937l-0.96118 0.0724q-0.07751-0.7183-0.5271-1.0852-0.44442-0.3669-1.3177-0.3669-0.9095 0-1.3281 0.33589-0.41341 0.33073-0.41341 0.80099 0 0.40824 0.29455 0.67179 0.28939 0.26355 1.5089 0.5426 1.2247 0.27388 1.6795 0.48059 0.66146 0.30489 0.97668 0.77514 0.31522 0.46509 0.31522 1.0749 0 0.60461-0.34623 1.142-0.34623 0.53227-0.99735 0.83199-0.64595 0.29456-1.4573 0.29456-1.0284 0-1.726-0.29973-0.69246-0.29972-1.0904-0.89916-0.39274-0.60462-0.41341-1.3643z",
    style: {
      shapeInside: "url(#rect14)",
      whiteSpace: "pre"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d3157773.svg";
export { ForwardRef as ReactComponent };